// @flow
/* eslint-disable prettier/prettier */

import loadable from '@loadable/component';

import {Layout} from 'antd';
import classNames from 'classnames';
import React, {useCallback, useState} from 'react';
import {QueryClient, QueryClientProvider} from 'react-query';

import Seo from '_components/Seo';
import Dots from '_images/spheredots.svg';

import styles from './index2.module.less';

const Navbar = loadable(() => import('_components/Navbar'));

const {Header, Content} = Layout;

type Props = {
  children: React$Node,
  floatingNavbar?: boolean,
  inverseFooter?: boolean,
  footerTrianglePosition?: 'left' | 'right',
  navbarTemplate?: 'default' | 'sign-in' | 'checkout' | 'profile',
};

const AppLayout = ({
  children,
  floatingNavbar = true,
  inverseFooter = false,
  footerTrianglePosition,
  navbarTemplate = 'default',
}: Props): React$Node => {
  const queryClient = new QueryClient();

  const [fullMenuVisible, setFullMenuVisible] = useState(false);

  const toggleFullMenu = useCallback(() => setFullMenuVisible(v => !v), []);

  return (
    <QueryClientProvider client={queryClient}>
      <Seo />
      <Layout
        className={classNames(styles.Layout, 'rf-layout')}
        style={{
          flexDirecton: 'column',
          backgroundRepeat: 'repeat',
          backgroundPosition: 'center center',
        }}>
        <Content className={styles.Content}>{children}</Content>
      </Layout>
    </QueryClientProvider>
  );
};

export default AppLayout;
